import { render, staticRenderFns } from "./VaccinationMailPopup.vue?vue&type=template&id=2009d9b0&scoped=true&"
import script from "./VaccinationMailPopup.vue?vue&type=script&lang=js&"
export * from "./VaccinationMailPopup.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationMailPopup.vue?vue&type=style&index=0&id=2009d9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2009d9b0",
  null
  
)

export default component.exports